<template>
  <div class="dashboard" style="height: 100%; width: 100%">
    <div class="loading" v-if="loading">Uploading...</div>
    <div
      style="
        width: 90%;
        height: 90%;
        top: 5%;
        left: 5%;
        position: fixed;
        box-sizing: border-box;
      "
    >
      <div class="filename">{{ filename }}</div>
      <input
        type="file"
        id="file"
        ref="file"
        v-on:change="handleFileUpload()"
        class="inputfile"
      />
      <label for="file" class="fileselector" v-if="!file">Choose a file</label>
      <label for="file" class="fileselector" v-else>Change file</label>

      <div style="width: 100%; height: 24px;"></div>

      <div class="uploadMsg">{{ uploadMsg }}</div>
      <button v-on:click="submitFile()" class="submitButton">Submit</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Home",
  components: {},
  data: () => ({
    items: [],
    filename: "",
    uploadMsg: "",
    loading: false,
    file: null
  }),
  mounted() {
    var globv = this;
    let inputs = globv.getUrlVars();
    globv.token = inputs.token || inputs.pass;
  },
  methods: {
    finishLoading: function () {
      var globv = this;
      setTimeout(globv.$refs.loadScreen.finishLoading, 800);
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.filename = this.$refs.file.files[0].name;
      this.uploadMsg = '';
    },
    getUrlVars: function() {
      var vars = {};
      window.location.href.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function(m, key, value) {
          vars[key] = value;
        }
      );
      return vars;
    },
    submitFile() {
      let globv = this;
      if (globv.file) {
        let formData = new FormData();

        formData.append("file", this.file);

        globv.loading = true;
        axios
          .post("/api/uploadData", formData, {
            params: { token: globv.token },
            headers: {
              "Content-Type": "multipart/form-data",
            }
          })
          .then(function () {
            console.log("SUCCESS!!");
            globv.loading = false;
            globv.uploadMsg = "Success";
            globv.file = null;
          })
          .catch(function () {
            console.log("FAILURE!!");
            globv.loading = false;
            globv.uploadMsg = "Upload Error, please contact administrator.";
          });
      }
      else {
        globv.uploadMsg = 'File not selected.'
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss">
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.inputfile + label {
  font-size: 1.25em;
  font-weight: 700;
  color: white;
  background-color: black;
  display: inline-block;
}
.inputfile:focus + label,
.inputfile + label:hover {
  background-color: red;
  cursor: pointer;
}

.filename {
  padding: 10px;
  font-size: 17px;
  height: 44px;
  border: 1px solid grey;
  float: left;
  width: 80%;
  background: #f1f1f1;
}

.fileselector {
  float: left;
  width: 20%;
  padding: 10px;
  background: #2196f3;
  color: white;
  font-size: 17px;
  border: 1px solid grey;
  border-left: none;
  cursor: pointer;
}

.uploadMsg {
  padding: 10px;
  font-size: 17px;
  height: 44px;
  float: left;
  width: 80%;
  display: inline;
}

.submitButton {
  padding: 10px;
  font-size: 17px;
  height: 44px;
  float: left;
  width: 20%;
  background: #2196f3;
  display: inline;
}

.submitButton:hover {
  cursor: pointer;
}

.loading {
  z-index: 1;
  height: 100%;
  width: 100%;
  top: 0%;
  left: 0%;
  position: absolute;
  opacity: 0.5;
  background: #808080;
}

.contentDash {
  overflow: scroll;
  margin: auto;
  right: 45vw;
  width: 40vw;
  position: fixed;
}
.upload {
  overflow: scroll;
  margin: auto;
  left: 5vw;
  width: 40vw;
  position: fixed;
}
.contentDash::-webkit-scrollbar {
  display: none;
}
.arcgisItem {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  align-self: center;
  width: 100%;
  flex: 1 0 auto;

  > .card {
    max-width: 1140px;
    width: 80%;
  }

  .dashFlexContent {
    width: 80%;

    .chart {
      width: 400px;
    }
  }
}
.contentButton {
  display: flex;
  position: absolute;
  top: 10px;
  right: 10px;

  a {
    padding: 5px 10px;
    display: flex;
    align-items: flex-end;
  }
}
.navBtn {
  align-self: center;
  background-color: #2f55a4;
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: white;
  background-color: var(--primaryColor);
  color: var(--primaryTextColor);
  text-decoration: none;
  padding: 10px 12px;
  border-radius: 5px;
  transform: scale(1);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;

  &:hover,
  &:focus,
  &:active {
    transform: scale(1.1);
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.5);
  }
}
.backBtn {
  align-self: center;
  background-color: #2f55a4;
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  background-color: var(--primaryColor);
  color: var(--primaryTextColor);
  text-decoration: none;
  padding: 10px 12px;
  border-radius: 5px;
  transform: scale(1);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;

  &:hover,
  &:focus,
  &:active {
    transform: scale(1.1);
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.5);
  }
}
.contentCard {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 10px;
  background-color: #fffafa;
  pointer-events: all;
  overflow: hidden;
  margin-top: 10px;
  margin-bottom: 10px;
  position: relative;
}
.contentTitle {
  font-weight: bold;
  font-size: large;
  margin-bottom: 10px;
}
.button {
  text-align: center;
  display: inline-block;
  margin: 0 10px;
  cursor: pointer;
}
.blue {
  background-color: var(--primary);
  color: #fffafa;
}
.grey {
  background-color: grey;
  color: #fffafa;
}
.red {
  background-color: #d62d20;
  color: #fffafa;
}
.green {
  background-color: #0ee831;
  color: #fffafa;
}
.keyInput {
  padding: 8px;
  display: inline-block;
  border: none;
  background-color: #fffafa;
  border: 1px solid #ccc;
  width: 75%;
}
.input {
  display: inline-block;
  border: none;
  background-color: #fffafa;
  border: 1px solid #ccc;
  width: 100%;
}
.blockingMenu {
  position: fixed;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  background-color: rgba(105, 105, 105, 0.6);
}
.blockingCard {
  position: fixed;
  vertical-align: center;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
.blockingTitle {
  display: inline-block;
  margin-right: 10px;
}
.rightButtons {
  display: grid;
  justify-content: end;
}
</style>